import React from "react";
import { FieldError, RegisterOptions, UseFormRegister } from "react-hook-form";
import { normalizeEmail } from "../../utils/normalizeEmail";

type InputProps = {
  name: string;
  register: UseFormRegister<any>; // todo: どこかで定義したい
  placeholder: string;
  isSmall?: boolean; // todo: もういっそclassNameを指定させる方がいいか？
  options: RegisterOptions;
  error?: FieldError;
};

// <input>要素を含んだ子コンポーネント
// フォーカスアウト時にメールアドレスを正規化（斜体・全角 → 半角）してからバリデーションする（issue #3302）
export const InputEmail: React.VFC<InputProps> = (props) => {
  const { name, register, placeholder, isSmall, options, error } = props;
  // setValueAs: blur を経ずに送信（Enter 等）された場合でも、フォーム値としては常に正規化済みにする
  const { onBlur, ...registered } = register(name, {
    ...options,
    setValueAs: (value) => (typeof value === "string" ? normalizeEmail(value) : value),
  });

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    // 表示も半角に揃える。react-hook-form は blur 時に ref(=この要素) から値を読むため、先に DOM の値を書き換える
    event.target.value = normalizeEmail(event.target.value);
    return onBlur(event);
  };

  return (
    <>
      <input
        type="mail"
        className={
          "form-input-text" +
          (isSmall ? " small" : "") +
          (error ? " error" : "")
        }
        placeholder={placeholder}
        {...registered}
        onBlur={handleBlur}
      />
    </>
  );
};
